/*
    Component based on RecommendedPropertyItem

    TODO: Analyse possible shared component between those
 */

import React, {PropsWithChildren} from "react";
import {css, cx} from "@panda/css";

import {CalendarCheckIcon} from "@pg-design/icons-module";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";
import {areaFormat, dateTimeFormat, formatFutureDate, pluralize} from "@pg-mono/string-utils";

import {LeadRodoText} from "../../application/components/LeadRodoText";
import {getOfferTypeNameCapital} from "../../offer/helpers/OfferType";
import {IRangeQuery} from "../../request/IRangeQuery";

type IProps = PropsWithChildren<{
    id: number;
    offerType: number;
    offerName: string;
    offerVendorName: string;
    offerAddress: string;
    offerPrivacyDataProcessorName: string | null;
    offerPrivacyPolicyUrl: string | null;
    offerPersonalDataProcessorUrl?: string | null;
    rooms: number;
    area: number;
    constructionDateRange?: Pick<IRangeQuery<string>, "upper">; // TODO check if it can be really optional (api calls providing properties), if not, make it required
    imageSrc?: string;
    className?: string;
}>;

export const PropertyListItem = (props: IProps) => {
    const {children, className, ...propertyData} = props;
    const {imageSrc, offerType, offerVendorName, id, rooms, area, constructionDateRange, ...offerData} = propertyData;
    const {offerName, offerAddress, offerPrivacyPolicyUrl, offerPrivacyDataProcessorName, offerPersonalDataProcessorUrl} = offerData;

    const displayType = getOfferTypeNameCapital(offerType);
    const ariaLabel = id + "label";
    const roomsPluralize = pluralize(["pokój", "pokoje", "pokoi"]);

    return (
        <div className={cx(propertyListItemStyles, className)}>
            <div className={imageAndDataContainerStyles}>
                <Image className={propertyImageStyles} src={imageSrc} width="123px" height="80px" ratio={{xs: "123/80"}} alt={`${offerVendorName}-${id}`} />

                <div className={propertyDataContainerStyles}>
                    <Text variant="body_copy_1" className={propertyTitleStyles} id={ariaLabel}>
                        {`${displayType}, ${rooms} ${roomsPluralize(rooms)}, ${areaFormat(area)}`}
                    </Text>
                    <Text variant="info_txt_3" className={propertyInfoStyles}>
                        {offerName}, {offerAddress}
                    </Text>

                    {constructionDateRange && (
                        <div className={pictogramsContainerStyles}>
                            <CalendarCheckIcon size="1.6" wrapperSize="2.4" wrapperType="square" wrapperColor="transparent" />
                            <Text variant="info_txt_2" className={css({ml: 0.5})}>
                                {formatFutureDate(constructionDateRange.upper, dateTimeFormat.quarterLong)}
                            </Text>
                        </div>
                    )}
                </div>
            </div>

            <LeadRodoText
                vendorName={offerVendorName}
                privacyPolicyUrl={offerPrivacyPolicyUrl}
                privacyDataProcessorName={offerPrivacyDataProcessorName}
                personalDataProcessorUrl={offerPersonalDataProcessorUrl}
                className={rodoTextStyles}
            />

            {children}
        </div>
    );
};

/*
    Styles
 */
const propertyListItemStyles = css({
    borderRadius: 1,
    border: "1px solid var(--colors-gray-500)"
});

const imageAndDataContainerStyles = css({
    display: "flex"
});

const propertyImageStyles = css({
    borderTopLeftRadius: 1,
    borderBottomRightRadius: 1,
    mr: 1,
    flex: "0 0 123px",
    overflow: "hidden",

    "& img": {
        width: "100%",
        height: "100%",
        objectFit: "cover"
    }
});

const propertyDataContainerStyles = css({
    mt: 1,
    mr: 1,
    ml: 0,
    mb: 0,
    display: "flex",
    flexDirection: "column",
    sm: {
        width: "65%",
        padding: 0
    }
});

const propertyTitleStyles = css({
    pb: 0.5
});

const propertyInfoStyles = css({
    color: "var(--colors-gray-700)",
    pb: 0.5
});

const pictogramsContainerStyles = css({
    display: "flex",
    alignItems: "center"
});

const rodoTextStyles = css({
    py: 1.5,
    px: 0.5
});
/*
    Component based on RecommendedPropertyItem

    TODO: Analyse possible shared component between those
 */

import React, {PropsWithChildren} from "react";
import {css, cx} from "@panda/css";

import {CalendarCheckIcon} from "@pg-design/icons-module";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";
import {areaFormat, dateTimeFormat, formatFutureDate, pluralize} from "@pg-mono/string-utils";

import {LeadRodoText} from "../../application/components/LeadRodoText";
import {getOfferTypeNameCapital} from "../../offer/helpers/OfferType";
import {IRangeQuery} from "../../request/IRangeQuery";

type IProps = PropsWithChildren<{
    id: number;
    offerType: number;
    offerName: string;
    offerVendorName: string;
    offerAddress: string;
    offerPrivacyDataProcessorName: string | null;
    offerPrivacyPolicyUrl: string | null;
    offerPersonalDataProcessorUrl?: string | null;
    rooms: number;
    area: number;
    constructionDateRange?: Pick<IRangeQuery<string>, "upper">; // TODO check if it can be really optional (api calls providing properties), if not, make it required
    imageSrc?: string;
    className?: string;
}>;

export const PropertyListItem = (props: IProps) => {
    const {children, className, ...propertyData} = props;
    const {imageSrc, offerType, offerVendorName, id, rooms, area, constructionDateRange, ...offerData} = propertyData;
    const {offerName, offerAddress, offerPrivacyPolicyUrl, offerPrivacyDataProcessorName, offerPersonalDataProcessorUrl} = offerData;

    const displayType = getOfferTypeNameCapital(offerType);
    const ariaLabel = id + "label";
    const roomsPluralize = pluralize(["pokój", "pokoje", "pokoi"]);

    return (
        <div className={cx(propertyListItemStyles, className)}>
            <div className={imageAndDataContainerStyles}>
                <Image className={propertyImageStyles} src={imageSrc} width="123px" height="80px" ratio={{xs: "123/80"}} alt={`${offerVendorName}-${id}`} />

                <div className={propertyDataContainerStyles}>
                    <Text variant="body_copy_1" className={propertyTitleStyles} id={ariaLabel}>
                        {`${displayType}, ${rooms} ${roomsPluralize(rooms)}, ${areaFormat(area)}`}
                    </Text>
                    <Text variant="info_txt_3" className={propertyInfoStyles}>
                        {offerName}, {offerAddress}
                    </Text>

                    {constructionDateRange && (
                        <div className={pictogramsContainerStyles}>
                            <CalendarCheckIcon size="1.6" wrapperSize="2.4" wrapperType="square" wrapperColor="transparent" />
                            <Text variant="info_txt_2" className={css({ml: 0.5})}>
                                {formatFutureDate(constructionDateRange.upper, dateTimeFormat.quarterLong)}
                            </Text>
                        </div>
                    )}
                </div>
            </div>

            <LeadRodoText
                vendorName={offerVendorName}
                privacyPolicyUrl={offerPrivacyPolicyUrl}
                privacyDataProcessorName={offerPrivacyDataProcessorName}
                personalDataProcessorUrl={offerPersonalDataProcessorUrl}
                className={rodoTextStyles}
            />

            {children}
        </div>
    );
};

/*
    Styles
 */
const propertyListItemStyles = css({
    borderRadius: 1,
    border: "1px solid var(--colors-gray-500)"
});

const imageAndDataContainerStyles = css({
    display: "flex"
});

const propertyImageStyles = css({
    borderTopLeftRadius: 1,
    borderBottomRightRadius: 1,
    mr: 1,
    flex: "0 0 123px",
    overflow: "hidden",

    "& img": {
        width: "100%",
        height: "100%",
        objectFit: "cover"
    }
});

const propertyDataContainerStyles = css({
    mt: 1,
    mr: 1,
    ml: 0,
    mb: 0,
    display: "flex",
    flexDirection: "column",
    sm: {
        width: "65%",
        padding: 0
    }
});

const propertyTitleStyles = css({
    pb: 0.5
});

const propertyInfoStyles = css({
    color: "var(--colors-gray-700)",
    pb: 0.5
});

const pictogramsContainerStyles = css({
    display: "flex",
    alignItems: "center"
});

const rodoTextStyles = css({
    py: 1.5,
    px: 0.5
});
